var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('div',{ref:"backgroundselect",staticClass:"color-picker picker",style:({
         backgroundColor:
         '#' +
         this.productInfo.palettecolors.find(
         function (p){ return p.flossId == this$1.userProduct.bgFlossId; }
        ).flossHtml,
        backgroundImage:
        'url(' +
        (this.productInfo.backgroundimages.find(
        function (p){ return p.backgroundImageId == this$1.userProduct.bgImageId; }
        ) ? this.productInfo.backgroundimages.find(
        function (p){ return p.backgroundImageId == this$1.userProduct.bgImageId; }
        ).backgroundImageUrl : '')


        + ')',
        }),attrs:{"title":this.productInfo.backgroundimages.find(
        function (p){ return p.backgroundImageId == this$1.userProduct.bgImageId; }
        ) ?
        this.productInfo.backgroundimages.find(
        function (p){ return p.backgroundImageId == this$1.userProduct.bgImageId; }
        ).backgroundImageName :
        'Background Color : ' +
        this.productInfo.palettecolors.find(
        function (p) { return p.flossId == this$1.userProduct.bgFlossId; }
        ).flossName},on:{"click":function($event){$event.stopPropagation();return _vm.openPopup.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(this.productInfo.palettecolors.find(function (p) { return p.flossId == this$1.userProduct.bgFlossId; }).flossName))])]),(_vm.active == true)?_c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-content"},[_c('h3',[_vm._v("Solid Background")]),_c('PaletteColors',{ref:"paletteColors",attrs:{"flossId":_vm.userProduct.bgFlossId},on:{"change-color":_vm.setColor}}),_c('h3',[_vm._v("Pattern Background")]),_c('BackgroundImages',{ref:"backgroundImages",attrs:{"backgroundImageId":_vm.userProduct.bgImageId},on:{"change-background-image":_vm.setBackgroundImage}})],1),_c('div',{staticClass:"overlay",on:{"click":function($event){_vm.active = false}}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }